import React, { useEffect, useState } from 'react'
import CloudRestroUsers from '../../../services/DatabaseService/CloudRestroUsers';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Button, Card, CardBody, Col, Input, Row } from 'reactstrap';
import Flatpickr from "react-flatpickr"
import CustomDataTable from '../../../Components/CustomTable/CustomTable';
import { Link } from 'react-router-dom';
import { formatDate, getTimeOnly } from '../../../Components/Common/FormatDate';
import UpdateExpiry from './component/UpdateExpiry';
import { Triangle } from 'react-loader-spinner';

const CloudRestroUser = () => {

  const [userdata, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [filterName, setFilterName] = useState("");
  const [updateExpiryOpen, setUpdateExpiryOpen] = useState(false);
  const [org, setOrg] = useState(null);

  const toggleUpdateExpiry = () => {
    setUpdateExpiryOpen(!updateExpiryOpen);
  }

  useEffect(() => {
    console.log("Useeffect triggered")
    const fetchData = async () => {
      try {
        const result = await CloudRestroUsers.getrestrousers();
        console.log(result)
        setUserData(result);
        console.log(result[0].orgCode)

      } catch (error) {
        console.error("Failed to fetch Data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const filteredData = userdata.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      ) ||
      (item.database?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      )
  );


  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  }

  const columns = [
    {
      name: "S No",
      cell: (row, index) => <div className=" pe-4">{index + 1}</div>,
      width: "90px",
      sortable: true,
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <Link to={`/cloudrestrousersdetails/${row?.orgCode}`}>
          <div style={{ whiteSpace: "wrap" }}>
            <strong><span title={row.name}>{row.name}</span></strong>
            <br />
            {/* <small className="text-muted">{row.tenantCode}</small> */}
          </div>
        </Link>
      ),
    },


    {
      name: "Email",
      selector: (row) => <span title={row.email} className="d-block text-wrap text-break">
        {row.email}
      </span>,
      sortable: true,
      width: "180px"
    },

    {
      name: "Address 1",
      selector: (row) => <span title={row.address1} className="d-block text-wrap text-break">
        {row.address1}
      </span>,
      sortable: true,
      width: "120px"
    },
    // {
    //   name: "Address 2 ",
    //   selector: (row) => <span title={row.email} className="d-block text-wrap text-break">
    //     {row.address2}
    //   </span>,
    //   sortable: true,
    //   width: "150px"
    // },
    {
      name: "Phone",
      selector: (row) => <span title={row.contactNo} className="d-block text-wrap text-break">
        {row.tel}
      </span>,
      sortable: true,
      width: "130px"
    },
    {
      name: "Joined Date",
      selector: (row) => <span title={row.expiryDate} className="d-block text-wrap text-break">
        {formatDate(row.joinedDate)}
      </span>,
      sortable: true,
      width: "135px"
    },
    {
      name: "Expiry Date",
      selector: (row) => <span title={row.expiryDate} className="d-block text-wrap text-break">
        {formatDate(row.expiryDate)}
      </span>,
      sortable: true,
      width: "135px"
    },
    
    {
      name: "Status",
      selector: "isActive",
      sortable: true,
      width: "95px",
      cell: (row) => (
        <span
          className={`badge ${row.isActive ? "bg-success" : "bg-danger"
            }`}
        >
          {row.isActive ? "True" : "False"}
        </span>
      ),
    },

    {
      name: "Action",
      cell: (row) => (
        <div>
          <Button color="btn btn-soft-warning" className="btn-sm ms-1 p-0" onClick={() => {
            setOrg(row.orgCode);
            toggleUpdateExpiry();
          }}
          >
            <i className="ri-edit-line " />
          </Button>
        </div>
      ),
      width:"80px",
      center: true,
    },
  ];


  return (
    <div className='page-content'>
      <div className="container-fluid">
        <BreadCrumb title="" pageTitle="Cloud Restro Users" />
      </div>

      <Row className="mb-3 align-items-end">
        <Col md={6} className="mb-2">
          <Input
            placeholder="Search by Name"
            value={filterText}
            onChange={handleFilterChange}
          />
        </Col>

        {/* <Col md={3} className="mb-2">
          <Input
            placeholder="Search by TenantCode"
            // value={filterTenantCode}
            // onChange={(e) => setFilterTenantCode(e.target.value)}
          />
        </Col> */}

        {/* <Col md={2} className="mb-2">
          <Flatpickr
            className="form-control"
            placeholder="Registered Date"
            // value={registeredDateRange}
            // onChange={(dates) => setRegisteredDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </Col> */}

        {/* <Col md={2} className="mb-2">
          <Flatpickr
            className="form-control"
            placeholder="Valid Date"
            // value={validDateRange}
            // onChange={(dates) => setValidDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </Col> */}

        {/* <Col md={1} className="mb-2 d-flex align-items-center">
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id="filterBoolean"
              // checked={filterBoolean}
              onChange={(e) => {
                // const newValue = !filterBoolean;
                // setFilterBoolean(newValue);
                fetchData(filterTenantName, filterTenantCode, newValue);
              }}
            />
            <label className="form-check-label pb-2" htmlFor="">
              Active
            </label>
          </div>
        </Col> */}
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            // paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 60, 100, 200, 300, 400, 500, 1000,]}
            // paginationComponentOptions={{
            //   selectAllRowsItem: true,
            //   selectAllRowsItemText: `Show All (${filteredData.length})`
            // }}
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">
                      <strong>ID:</strong> {item.id}
                    </h6>

                    <h6 className="mb-2">
                      <strong>Name:</strong> {item.name}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Email:</strong> {item.email}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Address 1:</strong> {item.address1}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Phone:</strong> {item.tel}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Expiry Date:</strong> {formatDate(item.expiryDate)}
                    </h6>
                    {/* <h6 className="mb-2">
                      <strong>Description:</strong> {item.description}
                    </h6> */}
                    <span
                      className={`badge ${item.isActive ? "bg-success" : "bg-danger"
                        }`}
                    >
                      {item.isActive ? "Active" : "Inactive"}
                    </span>{" "}

                  </Col>
                  {/* <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((userItem) =>
                              userItem.id === item.id
                                ? {
                                    ...userItem,
                                    dropdownOpen: !userItem.dropdownOpen,
                                  }
                                : { ...userItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col> */}
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
      <UpdateExpiry
        // orgcode={userdata?.orgCode}
        orgcode={org}
        modalOpen={updateExpiryOpen}
        toggleModal={toggleUpdateExpiry}
      />
    </div>
  )
}

export default CloudRestroUser;
